import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import * as ROUTE from 'constants/appRouting'
import 'styles/app/apps/projected-sites-manager.scss'
import { SITE_TYPE_REGEXP, SITE_TYPE_SEAWATER } from 'constants/index'
import ProjectedSitesManagerLayout from './ProjectedSitesManagerLayout'

function ProjectedSitesManager(props) {
  const {
    location: { pathname: url },
    history,
  } = props

  useEffect(() => {
    if (!url.match(SITE_TYPE_REGEXP)) {
      history.replace(
        `${ROUTE.PROJECTED_SITES_MANAGER}/${SITE_TYPE_SEAWATER}/main-table`,
      )
    }
  }, [url])

  return (
    <Switch>
      <Route path={ROUTE.PROJECTED_SITES_MANAGER_SITE_PATTERN}>
        <ProjectedSitesManagerLayout {...props} />
      </Route>
    </Switch>
  )
}

export default ProjectedSitesManager
